<div class="grid-x">
  <div class="cell small-6">
    Filter Notes:<span class="padding-left"><button (click)="toggleFiltering(!filterOpened)"><svg-icon icon="icon-data-lookup" class="small" [ngClass]="{ 'black': !filterOpened, 'red': filterOpened }"></svg-icon></button></span>
  </div>
  <div class="cell small-6">
    Showing {{ shownNotes }} of {{ totalNotes }} notes.
  </div>
  @if (filterOpened) {
    <div class="cell small-2 minor-margin-top shrink-font">
      By Type:
    </div>
    <div class="cell small-10 minor-margin-top shrink-font">
      <select name="type" [(ngModel)]="currentFilter.type" (ngModelChange)="filterChanged($event)">
        @for (t of typeFilter; track t) {
          <option [value]="t.id">
            {{ t.value }}
          </option>
        }
      </select>
    </div>
    <div class="cell small-2 shrink-font">
      From Date:
    </div>
    <div class="cell small-4 shrink-font">
      <common-date-picker [id]="'fromDate'" (dateUpdated)="onFromDateChanged($event)" [alignRight]="false"></common-date-picker>
    </div>
    <div class="cell small-2 shrink-font padding-left">
      To Date:
    </div>
    <div class="cell small-4 shrink-font">
      <common-date-picker [id]="'toDate'" (dateUpdated)="onToDateChanged($event)" [initialDate]="currentFilter.toDate"></common-date-picker>
    </div>
    <div class="cell small-2 shrink-font">
      By User:
    </div>
    <div class="cell small-10 shrink-font">
      <select name="user" [(ngModel)]="currentFilter.userName" (ngModelChange)="filterChanged($event)">
        @for (u of userNames; track u) {
          <option [value]="u">
            {{u}}
          </option>
        }
      </select>
    </div>
  }

</div>
